import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-neutral-50 text-neutral-900">
      <div className="w-full max-w-sm">
        <div className="flex items-center mb-8">
          <span className="wordmark text-2xl text-neutral-900">Quantum Boas</span>
        </div>
        <h1 className="font-display text-3xl mb-1">Admin access</h1>
        <p className="text-neutral-500 text-sm mb-8">Manage listings, genetics and lineage.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input type="email" required placeholder="Email" value={email} data-testid="admin-email"
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white text-neutral-900 placeholder:text-neutral-400 border border-black/15 rounded-lg px-4 py-3 outline-none focus:border-emerald-500 transition-colors" />
          <input type="password" required placeholder="Password" value={password} data-testid="admin-password"
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white text-neutral-900 placeholder:text-neutral-400 border border-black/15 rounded-lg px-4 py-3 outline-none focus:border-emerald-500 transition-colors" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full py-3 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-700 transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
